import React, { useState } from 'react';
import { Button, Menu as BasicMenu } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export const Menu = ({ name, menuId, children, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id={menuId}
        aria-controls={open ? { menuId } : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        disableRipple
        sx={{ color: '#FFFFFF', fontFamily: 'Montserrat', fontWeight: '900' }}
        endIcon={<ArrowDropDownIcon />}
        {...props}>
        {name}
      </Button>
      <BasicMenu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby' : 'basic-button',
        }}
        sx={{ '& .MuiMenuItem-root': { fontFamily: 'Montserrat' } }}>
        {children}
      </BasicMenu>
    </div>
  );
};
